<template>
  <div
    class="flex h-full w-full flex-col overflow-hidden rounded bg-white shadow-normal shadow-gray-400"
  >
    <LightboxVideo
      v-if="itemData.wistiaCode"
      :video-data="video"
      class="aspect-video w-full"
    />
    <figure v-else class="relative block aspect-video w-full overflow-hidden">
      <img
        :src="contextThumbnail"
        :alt="itemData.name || itemData.caption"
        loading="lazy"
        class="pointer-events-none absolute left-0 top-0 block h-full w-full object-cover"
      />
    </figure>
    <div class="flex flex-col justify-between tablet:p-4 desktop:p-5">
      <div>
        <span
          v-if="itemData.caption"
          class="line-clamp-1 text-xs font-bold text-gray-600"
        >
          {{ itemData.caption }}
        </span>
        <h3
          class="mb-2 line-clamp-4 text-sm font-bold leading-6 tablet:text-base"
        >
          {{ itemData.name }}
        </h3>
      </div>
      <div class="flex justify-end">
        <TheNuxtLink
          :id="itemData.trackingCode"
          :title="itemData.name"
          :to="provideFormatUrl(itemData.link)"
          class="flex h-8 w-8 items-center justify-center rounded text-blue-400 hover:bg-blue-400 hover:text-white"
        >
          <IconArrow class="h-5 w-5" direction="right" />
        </TheNuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { IVideoData } from '@/components/Shared/Lightbox/Video.vue';
  import type { IItem } from '@/components/Shared/Suite/Resources/index.vue';
  import type { TUrlConnector } from '@/components/Shared/Suite/type.ts';

  interface IProps {
    itemData: IItem;
    urlConnector?: TUrlConnector;
  }

  const props = defineProps<IProps>();

  const { provideFormatUrl } = useFormatUrl();
  const { provideResponsiveImgUrl } = useSolutionsData();

  const video = computed(
    (): IVideoData => ({
      title: props.itemData.name,
      description: props.itemData.caption || '',
      url: props.itemData.wistiaCode || '',
      imageUrl: contextThumbnail.value,
    })
  );

  const contextThumbnail = computed((): string => {
    const { thumbnail } = props.itemData;
    if (!thumbnail) return '';

    if (props.urlConnector === 'solution') {
      return provideResponsiveImgUrl(thumbnail);
    }
    return thumbnail;
  });
</script>
